class InteractiveMap extends HTMLElement {
  #abortController;
  #hoverEls
  #curReveal
  #prevReveal

  constructor() {
    super();
    this.#hoverEls = this.querySelectorAll('[data-hover]');
  }

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } =  this.#abortController;
    //
    this.#hoverEls.forEach(el => {
      el.addEventListener('pointerover', (e) => this.#onOver(e), { signal });
      /* 
        mouseout because pointerout makes reveal el dissappear after touch on tablet, 
        mouseout allows reveal el to stay visible until next touch
      */
      el.addEventListener('mouseout', (e) => this.#onOut(e), { signal });
    })
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null
  }

  #onOver(e) {
    /* console.log('#onHover', e.currentTarget.dataset.name); */
    e.currentTarget.dataset.show = 'true';
    this.#curReveal = this.querySelector(`[data-reveal][data-name="${e.currentTarget.dataset.name}"]`);
    if (this.#curReveal) this.#curReveal.dataset.reveal = 'true';
  }

  #onOut(e) {
    /* console.log('#onOut',  e.currentTarget.dataset.name); */
    e.currentTarget.dataset.show = 'false';
    this.#prevReveal = this.querySelector(`[data-reveal][data-name="${e.currentTarget.dataset.name}"]`);
    if (this.#prevReveal) this.#prevReveal.dataset.reveal = 'false';
  }

}

customElements.define('interactive-map', InteractiveMap);